import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const captionVars = {
  touch: {
    size: 13,
    lineHeight: 14,
  },
  mouse: {
    size: 11,
    lineHeight: 12,
  },
} as const satisfies TextSizingConfigs;

const CaptionBase = {
  color: colors.bodyNeutralLight,
  [darkThemeSelector]: {
    color: colors.bodyNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const CaptionSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${captionVars.touch.size}`,
      lineHeight: `$${captionVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${captionVars.mouse.size}`,
      lineHeight: `$${captionVars.mouse.lineHeight}`,
    },
  },
};

export const CaptionMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${captionVars.touch.size - 1}`,
      lineHeight: `$${captionVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${captionVars.mouse.size - 1}`,
      lineHeight: `$${captionVars.mouse.lineHeight}`,
    },
  },
};

export const Caption = styled(Text, CaptionBase, {
  variants: {
    family: {
      regular: CaptionSansSizes,
      monospace: CaptionMonoSizes,
    },
    transform: {
      uppercase: {},
      none: {
        textTransform: 'none',
      },
    },
  },
  defaultVariants: {
    family: 'regular',
    transform: 'uppercase',
  },
});
Caption.displayName = 'Caption';
